import { render, staticRenderFns } from "./DepositoryMonthFoldersView.vue?vue&type=template&id=188394d9&scoped=true&lang=pug&"
import script from "./DepositoryMonthFoldersView.vue?vue&type=script&lang=ts&"
export * from "./DepositoryMonthFoldersView.vue?vue&type=script&lang=ts&"
import style0 from "./DepositoryMonthFoldersView.vue?vue&type=style&index=0&id=188394d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188394d9",
  null
  
)

export default component.exports